import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IChatAIAnswer } from '@/models/chatai/IChatAIAnswer';
import { IChatAIHealth } from '@/models/chatai/IChatAIHealth';
import { IChatAIQuestion } from '@/models/chatai/IChatAIQuestion';

export class ChatAIService {
    static async getAnswer(query: IChatAIQuestion[], signal?: AbortSignal): Promise<AxiosResponse<IChatAIAnswer>> {
        return $api.post(`/ChatAI/GetAnswer`, query, { signal });
    }
    static async getAgentAnswer(query: IChatAIQuestion[], signal?: AbortSignal): Promise<AxiosResponse<IChatAIAnswer>> {
        return $api.post(`/ChatAI/GetAgentAnswer`, query, { signal });
    }
    static async getAgentAnswerStatus(requestId: string, signal?: AbortSignal): Promise<AxiosResponse<IChatAIAnswer>> {
        return $api.get(`/ChatAI/GetAgentAnswerStatus/${requestId}`, { signal });
    }
    static async cancelRequest(requestId: string): Promise<AxiosResponse<void>> {
        return $api.post(`/ChatAI/CancelRequest/${requestId}`);
    }
    /**
     * Сводный статус AI-зависимостей. Бэк кэширует ответ на 5s.
     * AbortSignal сюда НЕ пробрасываем: при unmount хука сleanup-цепочка
     * abort'нет controller, и повторный $api.request(config) в 401-handler'е
     * получит уже aborted signal — это ломает refresh-retry. Игнорировать
     * устаревшие результаты должна вызывающая сторона (через fetchEpoch).
     */
    static async getHealth(): Promise<IChatAIHealth> {
        // Опрос раз в 30 с, пока открыт ИИ-чат: его отказ — не ошибка страницы для поддержки.
        const { data } = await $api.get<IChatAIHealth>(`/ChatAI/Health`, {
            suppressErrorNotification: true,
            skipSupportErrorLog: true,
        });
        return data;
    }
}
